"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ExtendableError_1 = __importDefault(require("./ExtendableError"));
class NotImplementedError extends ExtendableError_1.default {
    constructor(methodName) {
        super(`${methodName} has not been implemented`);
        this.methodName = methodName;
    }
}
exports.default = NotImplementedError;
